import axios from "axios";

// 获取主分类及子分类和对应所有的产品，仅显示名称
export const getAllMainCategoriesWithSubAndProducts = async () => {
  const resp = await axios.get(
    `/api/main-categories/all-with-sub-and-products`
  );
  if (resp) {
    return resp.data;
  }
};

// 获取主分类下的所有子分类及其产品
export const getSubCategoriesByMain = async (mainCategoryId) => {
  const resp = await axios.get(`/api/sub-categories/main/${mainCategoryId}`);
  return resp.data;
};

// 获取子分类及其所有产品
export const getSubCategoryWithProducts = async (subCategoryId) => {
  const resp = await axios.get(`/api/sub-categories/${subCategoryId}`);
  return resp.data;
};

// 根据ID获取主分类信息
export const getMainCategoryById = async (mainCategoryId) => {
  const resp = await axios.get(`/api/main-categories/${mainCategoryId}`);
  return resp.data;
};
// 获取产品详情
export const getProductDetail = async (productId) => {
  const resp = await axios.get(`/api/product/${productId}`);
  if (resp) {
    return resp.data;
  }
};

// 获取首页横幅数据（通过接口，而不是静态 JSON）
export const getHomeBanners = async () => {
  try {
    const resp = await axios.get(`/api/home-banners`);

    // 处理每条横幅，link 改为路由路径
    const banners = resp.data.map((item) => {
      // 优先用 productId，如果没有则 fallback
      const productId = item.productId || item.link?.split("/").pop() || "";
      return {
        ...item,
        link: `/product/${productId}`,
      };
    });

    return banners;
  } catch (err) {
    console.error("Failed to load home banners:", err);
    return [];
  }
};
